<template lang="pug">
  v-container(:class="[$vuetify.breakpoint.smAndUp ? 'px-9' : 'px-3']")
    v-row(justify="space-around")
      v-col.pb-0(cols="12" sm="5")

        v-subheader
          | {{ $t("позиции") }} {{ preferences.nktDictionary ? $t("нкт") : '' }}
          v-tooltip(v-if="preferences.nktDictionary" bottom)
            template(v-slot:activator="{ on, attrs }")
              v-icon.ml-1(small v-bind="attrs" v-on="on" color="grey") mdi-information-outline
            span {{ $t('при_сканировании_штрих_кода_маркировки_dotdotdot') }}

        v-row
          template(v-if="$isCordova()")
            v-col.pt-0.pb-0(:cols="preferences.exciseStamp ? 4 : 5")
              v-btn(height="40" block color="reForeground" @click="createNewItem()") + &nbsp; {{ $t("добавить") }}
            v-col.pt-0.pb-0(:cols="preferences.exciseStamp ? 4 : 5")
              v-btn(height="40" block color="reForeground" :loading="positionsLoading || positionLoading" @click="positionsDialog = true") ☰ &nbsp; {{ $t("Выбрать") }}
            v-col.pt-0.pb-0.d-flex(:cols="preferences.exciseStamp ? 4 : 2" style="justify-content: space-evenly;")
              template(v-if="preferences.exciseStamp")
                v-btn(icon small :loading="positionsLoading" @click="fetchPositionsBefore('small')")
                  v-icon(small) mdi-qrcode-scan
                v-btn(icon small :loading="positionsLoading" @click="fetchPositionsBefore()")
                  v-icon mdi-qrcode-scan
              template(v-else)
                v-btn(icon small :loading="positionsLoading" @click="fetchPositionsBefore()")
                  v-icon mdi-qrcode-scan
          template(v-else)
            v-col.pt-0.pb-3(cols="4")
              v-btn(height="40" block color="reForeground" @click="createNewItem()") {{ $t("добавить") }}
            v-col.pt-0.pb-3(cols="8" align="right")
              v-text-field.rounded-xl(ref="barcode" v-model="barcode" :placeholder="preferences.exciseStamp ? $t('штрих_код_маркировка') : $t('штрих_код')" @keydown.enter="processScanResult(barcode)" flat filled dense autocomplete="off" clearable hide-details :loading="positionsLoading || searchByBarcodeLoading" :disabled="positionsLoading || searchByBarcodeLoading" append-outer-icon="mdi-magnify" @click:append-outer="processScanResult(barcode)")
            v-col.pt-3.pb-1(cols="12")
              v-autocomplete.rounded-xl.autocomplete-with-append(v-model="autocompleteSelect" ref="autocomplete" :search-input.sync="autocompleteSearch" :placeholder="$t('наименование')" :items="autocompleteItems" item-text="name" return-object filled flat clearable hide-details :hide-no-data="!autocompleteSearch" :allow-overflow="false" :loading="positionsLoading" :disabled="positionsLoading" @change="autocompleteChanged")
                template(slot="item" slot-scope="{ item }")
                  v-list-item-content
                    v-list-item-title(v-dompurify-html="item.name")
                    v-list-item-subtitle {{ item.price | numeral('0,0.[00]') }} ₸ ({{ $t('unitType.' + item.unitType) }})
                template(v-slot:append-outer)
                  v-btn(icon small :loading="positionsLoading || positionLoading" @click="positionsDialog = true")
                    v-icon mdi-format-list-bulleted

        v-subheader(v-if="items.length > 0" style="justify-content: space-between") {{ $t("список") }}
          a(@click.prevent="clear()") Очистить
        v-list.py-0.re-v-list-fulltext(two-line)
          transition-group(name="list" tag="p")
            v-list-item(v-for="(item, $index) in items" :key="'i_' + $index" @click="editItem($index)" transition="slide-y-transition")
              v-list-item-content
                v-list-item-title {{ $index + 1 }}. {{ item.commodity.barcode ? 'GTIN: '+item.commodity.barcode : '' }} {{ item.commodity.ntin ? 'NTIN/XTIN: '+item.commodity.ntin : '' }} {{ item.commodity.name }}
                v-list-item-subtitle {{ item.commodity.realQuantity | numeral('0,0.[000]') }} {{ $t('unitType.' + item.commodity.unitType) }} &times; {{ item.commodity.price.value | numeral('0,0.[00]') }} ₸
                  | {{ item.commodity.discountValue ? ` - ${$options.filters.numeral(item.commodity.discountValue, '0,0.[00]')} ₸ (${$t('скидка')}${item.commodity.discountType === 'PERCENTAGE' ? ` ${item.commodity.discountPercentage}%` : ''}) ` : '' }}
                  | {{ item.commodity.markupValue ? ` + ${$options.filters.numeral(item.commodity.markupValue, '0,0.[00]')} ₸ (${$t('наценка')}${item.commodity.markupType === 'PERCENTAGE' ? ` ${item.commodity.markupPercentage}%` : ''}) ` : '' }}
              v-list-item-action
                v-list-item-action-text.headline {{ item.commodity.total | numeral('0,0.[00]') }} ₸
                v-list-item-action-text(v-if="item.commodity.taxes && item.commodity.taxes[0]") {{ item.commodity.taxes[0].sum.value | numeral('0,0.[00]') }} ₸ ({{ $t('в_т_ч_ндс') }} {{ item.commodity.taxes[0].percent / 1000 }}%)

      v-col.pt-0.pt-sm-3.pl-3.pl-sm-5(cols="12" sm="6")
        v-subheader {{ preferences.customerIinBin ? $t("дополнительно") : $t("скидка_наценка") }}
        v-list.py-0
          v-list-item(@click="editDiscountMarkup()")
            v-list-item-content
              v-list-item-title {{ $t("discountMarkupType." + discountMarkup.type + "_short") }}
            v-list-item-action
              v-list-item-action-text.headline {{ discountMarkup.valueOrPecentage > 0 ? (discountMarkup.type.includes('DISCOUNT') ? '-' : '+') : ''}} {{ discountMarkup.valueOrPecentage }} {{ dictionary.discountMarkupType[discountMarkup.type].suffix }}
          v-list-item(v-if="preferences.customerIinBin" @click="editСustomerIinBin()")
            v-list-item-content
              v-list-item-title {{ $t("иин_бин") }}
            v-list-item-action
              v-list-item-action-text.subtitle-1 {{ customerIinBin }}

        v-subheader {{ $t("оплата") }}
        v-list.payments.py-0
          //- HALYK_QR_ROLLOUT_GATE: visiblePayments вместо payments
          v-list-item(v-for="(payment, $index) in visiblePayments" :key="'i_' + $index" @click="fillPayment($event, payment)")
            v-list-item-action
              v-icon.no-focus(id="selectPayment" @click="selectPayment($event, payment)") mdi-pencil
            v-list-item-content
              v-list-item-title
                | {{ payment.type === 'PAYMENT_QR' ? qrPaymentLabel : $t("paymentType." + payment.type) }}
                v-chip.ml-2.font-weight-bold(v-if="payment.type === 'PAYMENT_QR'" x-small color="red" dark) new
              v-list-item-subtitle.caption {{ $t("paymentType." + payment.type + "_tip") }}
            v-list-item-action
              v-list-item-action-text.headline {{ payment.sum | numeral('0,0.[00]') }} ₸

        v-subheader {{ $t("итого") }}
        v-list.py-0.no-color-background-list
          v-list-item
            v-list-item-content
              v-list-item-title {{ $t("к_оплате") }}
            v-list-item-action
              v-list-item-action-text.headline {{ totalSum | numeral('0,0.[00]') }} ₸
          v-list-item(v-if="longScreen")
            v-list-item-content
              v-list-item-title {{ $t("принято") }}
            v-list-item-action
              v-list-item-action-text.headline {{ paymentsSum | numeral('0,0.[00]') }} ₸
          v-list-item(v-if="longScreen")
            v-list-item-content
              v-list-item-title {{ $t("сдача") }}
            v-list-item-action
              v-list-item-action-text.headline {{ changeCash > 0 ? '-' : '' }} {{ changeCash | numeral('0,0.[00]') }} ₸

        v-row
          v-col
            v-btn(block color="secondary" @click="prepareTicketRequest()") {{ $t("далее") }}

    re-item(v-model="itemDialog" :item="editableItem" :preNewItem="preNewItem" @addItem="addItem" @saveItem="saveItem" @deleteItem="deleteItem" v-if="itemDialogRecreate")

    re-payment(v-model="paymentDialog" :payment="selectedPayment" :paymentsSum="paymentsSum" :total="totalSum" @savePayment="savePayment" v-if="paymentDialogRecreate")

    re-discount-markup(v-model="discountMarkupDialog" :discountMarkup="selectedDiscountMarkup" :total="totalSumWithoutDiscountMarkup" @saveDiscountMarkup="saveDiscountMarkup" v-if="discountMarkupDialogRecreate")

    re-customer-iin-bin(v-model="customerIinBinDialog" :customerIinBinProp="customerIinBin" @saveCustomerIinBin="saveCustomerIinBin")

    re-positions(v-model="positionsDialog" @positionSelected="positionSelected")

    re-rek-ofd-payment-notifier(v-if="cashRegister.fdo === 'REK'" calculatorMode)
    re-service-fee-payment-notifier(v-else calculatorMode)
    re-agreement
</template>

<script>
import Vue from 'vue'
import fdo from '@comrun/kfdo'
import { Decimal } from 'decimal.js'
import { mapState, mapActions } from 'vuex'
import dictionaryMixin from '../../../mixins/dictionaryMixin'
import billsAndCoinsMixin from '../../../mixins/billsAndCoinsMixin'
import qrPaymentMixin from '../../../mixins/qrPaymentMixin'
import TicketDetailsItem from './TicketDetailsItem.vue'
import TicketDetailsPayment from './TicketDetailsPayment.vue'
import TicketDetailsDiscountMarkup from './TicketDetailsDiscountMarkup.vue'
import TicketDetailsCustomerIinBin from './TicketDetailsCustomerIinBin.vue'
import Positions from './Positions.vue'
import REKOFDPaymentNotifier from '../../utils/REKOFDPaymentNotifier.vue'
import ServiceFeePaymentNotifier from '../../utils/ServiceFeePaymentNotifier.vue'
import Agreement from '../../utils/Agreement.vue'

export default {
  components: {
    're-item': TicketDetailsItem,
    're-payment': TicketDetailsPayment,
    're-discount-markup': TicketDetailsDiscountMarkup,
    're-customer-iin-bin': TicketDetailsCustomerIinBin,
    're-positions': Positions,
    're-rek-ofd-payment-notifier': REKOFDPaymentNotifier, 
    're-service-fee-payment-notifier': ServiceFeePaymentNotifier,
    're-agreement': Agreement,
  },

  mixins: [dictionaryMixin, billsAndCoinsMixin, qrPaymentMixin],

  data: () => ({
    ticketRequest: null,

    itemDialog: false,
    itemDialogRecreate: false,
    editableItem: null,
    editableItemIndex: null,

    paymentDialog: false,
    paymentDialogRecreate: false,
    selectedPayment: null,
    payments: [
      {
        type: 'PAYMENT_CASH',
        sum: 0,
      },
      {
        type: 'PAYMENT_CARD',
        sum: 0,
      },
      {
        type: 'PAYMENT_MOBILE',
        sum: 0,
      },
      {
        type: 'PAYMENT_QR',
        sum: 0,
      },
    ],

    discountMarkupDialog: false,
    discountMarkupDialogRecreate: false,
    selectedDiscountMarkup: null,
    discountMarkup: {
      type: 'DISCOUNT_PERCENTAGE',
      valueOrPecentage: 0,
      sum: 0,
      auxiliary: {
        key: 'DISCOUNT',
        value: '0%',
      },
    },

    preNewItem: null,
    barcode: null,

    autocompleteSelect: null,
    autocompleteSearch: null,
    autocompleteLoading: false,
    autocompleteItems: [],

    customerIinBinDialog: false,
    customerIinBin: null,

    searchByBarcodeLoading: false,

    positionsDialog: false,
    positionLoading: false,
  }),

  computed: {
    ...mapState({
      positionList: state => state.positions.list,
      positionsLoading: state => state.positions.loading,
      cashRegister: state => state.cashRegisters.cashRegister.cashRegister,
      preferences: state => state.cashRegisters.cashRegister.cashRegister.data.preferences,
      configuration: state => state.cashRegisters.cashRegister.cashRegister.data.configuration,
    }),

    // HALYK_QR_ROLLOUT_GATE: строка QR в списке оплат только при доступной фиче
    visiblePayments() {
      return this.halykQRAvailable ? this.payments : this.payments.filter((payment) => payment.type !== 'PAYMENT_QR')
    },

    // Items
    items() {
      return this.ticketRequest.items.map((item) => {
        item.commodity.realQuantity = new Decimal(item.commodity.quantity).dividedBy(1000).toNumber()
        item.commodity.price.value = this.getNumberFromBillsAndCoins(item.commodity.price)
        item.commodity.sum.value = this.getNumberFromBillsAndCoins(item.commodity.sum)
        item.commodity.total = item.commodity.sum.value

        // UnitType, Discount, Markup
        if (item.commodity.auxiliary) {
          // Item unitType
          const unitType = item.commodity.auxiliary.find((aux) => aux.key === 'UNIT_TYPE')
          item.commodity.unitType = unitType ? unitType.value : 'PIECE'

          // Item discount
          const discount = item.commodity.auxiliary.find((aux) => aux.key === 'DISCOUNT')
          if (discount) {
            item.commodity.discountType = discount.value.includes('%') ? 'PERCENTAGE' : 'VALUE'

            if (item.commodity.discountType === 'PERCENTAGE') {
              item.commodity.discountPercentage = discount.value.replace('%', '')
              item.commodity.discountValue = new Decimal(item.commodity.discountPercentage).times(item.commodity.total).dividedBy(100).toNumber()
                .toFixed(2)
            } else {
              item.commodity.discountValue = discount.value
              item.commodity.discountPercentage = new Decimal(item.commodity.discountValue).dividedBy(item.commodity.total).times(100).toNumber()
                .toFixed(2)
            }

            item.commodity.total = new Decimal(item.commodity.total).minus(item.commodity.discountValue).toNumber()
          }

          // Item markup
          const markup = item.commodity.auxiliary.find((aux) => aux.key === 'MARKUP')
          if (markup) {
            item.commodity.markupType = markup.value.includes('%') ? 'PERCENTAGE' : 'VALUE'

            if (item.commodity.markupType === 'PERCENTAGE') {
              item.commodity.markupPercentage = markup.value.replace('%', '')
              item.commodity.markupValue = new Decimal(item.commodity.markupPercentage).times(item.commodity.total).dividedBy(100).toNumber()
                .toFixed(2)
            } else {
              item.commodity.markupValue = markup.value
              item.commodity.markupPercentage = new Decimal(item.commodity.markupValue).dividedBy(item.commodity.total).times(100).toNumber()
                .toFixed(2)
            }

            item.commodity.total = new Decimal(item.commodity.total).plus(item.commodity.markupValue).toNumber()
          }
        }

        // Taxes
        if (item.commodity.taxes && item.commodity.taxes[0]) {
          item.commodity.taxes[0].sum.value = this.getNumberFromBillsAndCoins(item.commodity.taxes[0].sum)
          const discountMarkupTax = item.commodity.auxiliary.find((aux) => aux.key === 'DISCOUNT_MARKUP_TAX')
          if (discountMarkupTax) {
            item.commodity.taxes[0].sum.value = new Decimal(item.commodity.taxes[0].sum.value).plus(discountMarkupTax.value).toNumber().toFixed(2)
          }
        }

        return item
      })
    },

    totalSumWithoutDiscountMarkup() {
      return this.items.reduce((sum, item) => new Decimal(sum).plus(item.commodity.total).toNumber(), 0)
    },

    totalSum() {
      const total = this.items.reduce((sum, item) => new Decimal(sum).plus(item.commodity.total).toNumber(), 0)

      if (this.discountMarkup.type.includes('DISCOUNT')) {
        return new Decimal(total).minus(this.discountMarkup.sum).toNumber()
      }
      return new Decimal(total).plus(this.discountMarkup.sum).toNumber()
    },

    paymentsSum() {
      return this.payments.reduce((sum, payment) => new Decimal(sum).plus(payment.sum).toNumber(), 0)
    },

    takenCash() {
      return this.payments.find(payment => payment.type === 'PAYMENT_CASH').sum
    },

    changeCash() {
      const change = this.paymentsSum > 0 && this.totalSum > 0 ? new Decimal(this.paymentsSum).minus(this.totalSum).toNumber() : 0
      return change >= 0 ? change : 0
    },

    // Not reactive
    longScreen() {
      return window.innerHeight > 700
    },
  },

  watch: {
    autocompleteSearch(val) {
      val ? this.queryPositions(val) : this.autocompleteItems = []
    },
  },

  created() {
    // Restore ticketRequest or create new
    const ticketRequestFromStore = this.$store.state.cashRegisters.ticketRequest
    if (ticketRequestFromStore) {
      // Remove all except Commudity
      ticketRequestFromStore.items = ticketRequestFromStore.items.reduce((items, item) => {
        if (item.type === fdo.kkm.proto.TicketRequest.Item.ItemTypeEnum.ITEM_TYPE_COMMODITY) {
          items.push(item)
        }
        return items
      }, [])
      this.ticketRequest = ticketRequestFromStore

      // Restore payments
      const cashPayment = this.ticketRequest.payments.find((p) => p.type === fdo.kkm.proto.PaymentTypeEnum.PAYMENT_CASH)
      const cardPayment = this.ticketRequest.payments.find((p) => p.type === fdo.kkm.proto.PaymentTypeEnum.PAYMENT_CARD)
      const mobilePayment = this.ticketRequest.payments.find((p) => p.type === fdo.kkm.proto.PaymentTypeEnum.PAYMENT_MOBILE)
      // Мобильный платёж с QR-меткой показываем в строке QR
      const isQrPayment = this.hasQrPaymentMarker(this.ticketRequest)
      this.payments.find((p) => p.type === 'PAYMENT_CASH').sum = cashPayment ? new Decimal(this.getNumberFromBillsAndCoins(cashPayment.sum)).plus(this.getNumberFromBillsAndCoins(this.ticketRequest.amounts.change)).toNumber() : 0
      this.payments.find((p) => p.type === 'PAYMENT_CARD').sum = cardPayment ? this.getNumberFromBillsAndCoins(cardPayment.sum) : 0
      this.payments.find((p) => p.type === 'PAYMENT_MOBILE').sum = mobilePayment && !isQrPayment ? this.getNumberFromBillsAndCoins(mobilePayment.sum) : 0
      this.payments.find((p) => p.type === 'PAYMENT_QR').sum = mobilePayment && isQrPayment ? this.getNumberFromBillsAndCoins(mobilePayment.sum) : 0
      this.ticketRequest.payments = []

      // Restore discount
      if (this.ticketRequest.amounts.discount) {
        this.discountMarkup.sum = this.getNumberFromBillsAndCoins(this.ticketRequest.amounts.discount.sum)
        const discount = this.ticketRequest.amounts.discount.auxiliary.find((aux) => aux.key === 'DISCOUNT')
        if (discount) {
          if (discount.value.includes('%')) {
            this.discountMarkup.type = 'DISCOUNT_PERCENTAGE'
          } else {
            this.discountMarkup.type = 'DISCOUNT_CURRENCY'
          }
          this.discountMarkup.valueOrPecentage = discount.value.replace('%', '')
          this.discountMarkup.auxiliary = discount
        }
      }

      // Restore markup
      if (this.ticketRequest.amounts.markup) {
        this.discountMarkup.sum = this.getNumberFromBillsAndCoins(this.ticketRequest.amounts.markup.sum)
        const markup = this.ticketRequest.amounts.markup.auxiliary.find((aux) => aux.key === 'MARKUP')
        if (markup) {
          if (markup.value.includes('%')) {
            this.discountMarkup.type = 'MARKUP_PERCENTAGE'
          } else {
            this.discountMarkup.type = 'MARKUP_CURRENCY'
          }
          this.discountMarkup.valueOrPecentage = markup.value.replace('%', '')
          this.discountMarkup.auxiliary = markup
        }
      }

      // Restore customerIinBin
      if (this.ticketRequest.extensionOptions && this.ticketRequest.extensionOptions.customerIinOrBin) {
        this.customerIinBin = this.ticketRequest.extensionOptions.customerIinOrBin
      }
    } else {
      this.ticketRequest = new fdo.kkm.proto.TicketRequest()
    }

    if (localStorage.getItem('rekassa.kz-tools-openScanner') === 'true' || !this.$isCordova()) {
      localStorage.setItem('rekassa.kz-tools-openScanner', 'false')
      this.fetchPositionsBefore()
    }
  },

  mounted() {
    if (!this.$isCordova()) {
      window.addEventListener('keydown', this.keyListener, false)
    }
  },

  beforeDestroy() {
    if (!this.$isCordova()) {
      window.removeEventListener('keydown', this.keyListener, false)
    }
  },

  methods: {
    ...mapActions({
      setTicketRequest: 'cashRegisters/setTicketRequest',
      fetchPositions: 'positions/fetch',
      fetchNKT: 'positions/fetchNKT',
      analyticsLogEvent: 'analytics/logEvent',
      showSnackbar: 'tools/showSnackbar',
      showConfirm: 'confirm/showConfirm',
    }),

    // -------------------------------------- Autocomplete --------------------------------------
    queryPositions(v) {
      this.autocompleteItems = this.positionList.filter(item => (item.name || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1)
    },

    positionSelected(position) {
      this.positionLoading = true
      this.autocompleteSelect = position
      this.autocompleteChanged()
    },

    autocompleteChanged() {
      if (this.autocompleteSelect) {
        // Если включен режим НКТ и есть штрих-код, то ищем товар в НКТ
        if (this.preferences.nktDictionary && this.autocompleteSelect.barcode) {
          this.searchInNKT(this.autocompleteSelect.barcode)
        // Если выключен режим НКТ, то проверяем цену и добавляем товар в чек или показываем диалог добавления нового товара
        } else {
          if (this.autocompleteSelect.price > 0) {
            this.addItem(this.buildItem({
              name: this.autocompleteSelect.name,
              price: this.autocompleteSelect.price,
              unitType: this.autocompleteSelect.unitType,
              barcode: this.autocompleteSelect.barcode,
            }))
          } else {
            this.preNewItem = {
              name: this.autocompleteSelect.name,
              price: this.autocompleteSelect.price,
              unitType: this.autocompleteSelect.unitType,
            }
            if (this.autocompleteSelect.barcode) {
              if (this.autocompleteSelect.barcode.startsWith('020') && this.autocompleteSelect.barcode.length === 13) {
                this.preNewItem.ntin = this.autocompleteSelect.barcode
              } else {
                this.preNewItem.barcode = this.autocompleteSelect.barcode
              }
            }

            this.editableItem = null
            this.editableItemIndex = null
            this.showItemDialog()
          }

          this.positionLoading = false
          this.analyticsLogEvent({ eventName: 're_positions_used' })
        }

        this.$nextTick(() => {
          this.autocompleteSelect = ''
          this.autocompleteSearch = null
        })
      }
    },

    // -------------------------------------- Barcode --------------------------------------
    keyListener(event) {
      const reg = new RegExp('^[0-9\\.]$')
      if (!this.positionsLoading
            && !this.positionsDialog
            && !this.itemDialog
            && !this.paymentDialog
            && !this.discountMarkupDialog
            && !this.customerIinBinDialog
            && reg.test(event.key)
            && !this.$refs.barcode.isFocused
            && !this.$refs.autocomplete.isFocused) {
        this.$refs.barcode.focus()
      }
    },

    fetchPositionsBefore(type) {
      if (this.positionList.length === 0) {
        this.fetchPositions(this.cashRegister.id).then(() => {
          if (this.$isCordova()) {
            this.scan(type)
          }
        }).catch(() => {
          this.showSnackbar({ message: this.$t('произошла_ошибка') })
        })
      } else if (this.$isCordova()) {
        this.scan(type)
      }
    },

    scan(type) {
      const aspectRatio = parseInt(localStorage.getItem('rekassa.kz-ui-camera-aspectRatio') || 1, 10)
      if (type === 'small') {
        window.cordova.plugins.rekassaDataMatrix.scan((result) => {
          this.processScanResult(result)
        },
        () => {
        }, { aspectRatio })
      } else {
        window.cordova.plugins.rekassaBarcode.scan((result) => {
          this.processScanResult(result)
        },
        () => {
        }, { aspectRatio })
      }
    },

    processScanResult(input) {
      const result = this.parseScannedCode(input)
      console.log(result)
      if (result.exciseStamp) {
        this.searchByBarcode(result.barcode, result.exciseStamp)
        this.analyticsLogEvent({ eventName: 're_datamatrix_scanned' })
      } else {
        this.searchByBarcode(result.barcode)
        this.analyticsLogEvent({ eventName: 're_barcode_scanned' })
      }
    },

    parseScannedCode(value) {
      const fallback = { barcode: value, exciseStamp: null }

      if (!this.preferences.exciseStamp) {
        return fallback
      }

      try {
        if (!value || typeof value !== 'string') {
          return fallback
        }

        // Удаляем символ-разделитель GS (\u001d, ASCII 29) для проверок,
        // но оригинальный value сохраняем нетронутым для exciseStamp
        const cleaned = value.replaceAll('\u001d', '')

        // Проверка 1: только печатаемые ASCII-символы (0x21–0x7E)
        if (!/^[\x21-\x7E]+$/.test(cleaned)) {
          return fallback
        }

        // Проверка 2: формат кода маркировки GS1 DataMatrix
        const exciseStampRegex = /^01[0-9]{14}21[^ ]*$/
        if (!exciseStampRegex.test(cleaned) && cleaned.length !== 29) {
          // Не маркировка — возвращаем как обычный штрихкод
          return fallback
        }

        // Это маркировка — извлекаем GTIN (14 цифр)
        // Если есть префикс AI "01" — берём 14 цифр после него, иначе первые 14
        const gtinMatch = cleaned.match(/^(?:01)?([0-9]{14})/)
        if (!gtinMatch) {
          return fallback
        }

        const barcode = gtinMatch[1]

        return {
          barcode, // GTIN — для поиска товара
          exciseStamp: cleaned, // сырая маркировка — для передачи на бэкенд как есть
        }
      } catch {
        return fallback
      }
    },

    searchByBarcode(barcode, exciseStamp) {
      this.searchByBarcodeLoading = true
      if (this.preferences.nktDictionary) {
        this.searchInNKT(barcode || this.barcode, exciseStamp)
      } else {
        this.searchInPositionList(barcode || this.barcode, exciseStamp)
      }
      this.barcode = null
    },

    searchInNKT(barcode, exciseStamp) {
      this.fetchNKT(barcode).then((response) => {
        this.positionLoading = false
        if (response.data.length >= 1) {
          console.debug(response.data)

          // Если товар не зарегистрирован в НКТ, то показываем диалог
          if (response.data[0].xtin) {
            this.playSound('error')
            this.showConfirm({
              title: this.$t('уважаемый_пользователь'),
              text: this.$t('в_вашем_чеке_обнаружен_товар_dotdotdot'),
              resolveText: this.$t('перейти_на_сайт_nct_kz'),
              rejectText: this.$t('закрыть'),
            }).then(() => {
              this.$openLink('https://nct.kz', '_blank')
            }).catch(() => {
              this.preNewItem = {
                name: '',
                price: 0,
                unitType: 'PIECE',
                barcode,
                xtin: response.data[0].xtin,
                isMarked: false,
                exciseStamp,
              }
              this.editableItem = null
              this.editableItemIndex = null
              this.showItemDialog()
            })

            this.analyticsLogEvent({
              eventName: 're_nkt_not_registered',
              eventProperties: {
                gtin: barcode,
                xtin: response.data[0].xtin,
              },
            })
          // Если товар зарегистрирован в НКТ, то добавляем товар в чек
          } else {
            // Ищем товар в прайс-листе для получения цены
            const filterList = this.positionList.filter((item) => item.barcode === `${barcode}` || (item.barcodes && item.barcodes.includes(`${barcode}`)))
            const price = filterList.length === 1 ? filterList[0].price : 0
            const name = `${response.data[0].nameRu ? response.data[0].nameRu : ''}; ${response.data[0].nameKk && response.data[0].nameRu !== response.data[0].nameKk ? response.data[0].nameKk : ''}`
            const unitType = filterList.length === 1 ? filterList[0].unitType : 'PIECE'

            // Если товар найден в прайс-листе и цена больше 0, и товар без маркировки, то добавляем товар в чек
            if (filterList.length === 1 && price > 0 && !response.data[0].isMarked) {
              this.addItem(this.buildItem({
                name,
                price: filterList[0].price,
                unitType: filterList[0].unitType,
                barcode: response.data[0].gtin,
                ntin: response.data[0].ntin || response.data[0].xtin,
                exciseStamp,
              }))
            // Иначе показываем диалог добавления нового товара
            } else {
              this.preNewItem = {
                name,
                price,
                unitType,
                barcode: response.data[0].gtin,
                ntin: response.data[0].ntin,
                xtin: response.data[0].xtin,
                isMarked: response.data[0].isMarked,
                exciseStamp,
              }
              this.editableItem = null
              this.editableItemIndex = null
              this.showItemDialog()
            }
            this.playSound('found')

            this.analyticsLogEvent({
              eventName: 're_nkt_found',
              eventProperties: {
                gtin: barcode,
                ntin: response.data[0].ntin,
                name: `${response.data[0].nameRu ? response.data[0].nameRu : ''}; ${response.data[0].nameKk && response.data[0].nameRu !== response.data[0].nameKk ? response.data[0].nameKk : ''}`,
                isMarked: response.data[0].isMarked,
              },
            })
          }
        } else {
          this.showSnackbar({ message: this.$t('позиция_с_данным_штрих_кодом_не_найдена_в_справочнике_нкт') })
          this.playSound('error')
          this.positionLoading = false

          this.analyticsLogEvent({
            eventName: 're_nkt_not_found',
            eventProperties: {
              gtin: barcode,
            },
          })
        }
        this.searchByBarcodeLoading = false
      }).catch(() => {
        this.showSnackbar({ message: this.$t('сервис_национальный_каталог_товаров_НКТ_не_доступен') })
        this.playSound('error')
        this.searchByBarcodeLoading = false
        this.positionLoading = false

        this.analyticsLogEvent({
          eventName: 're_nkt_not_available',
          eventProperties: {
            gtin: barcode,
          },
        })
      })
    },

    searchInPositionList(barcode, exciseStamp) {
      const filterList = this.positionList.filter((item) => item.barcode === `${barcode}` || (item.barcodes && item.barcodes.includes(`${barcode}`)))
      if (filterList.length === 1) {
        if (filterList[0].price > 0) {
          if (barcode.startsWith('020') && barcode.length === 13) {
            this.addItem(this.buildItem({
              name: filterList[0].name,
              price: filterList[0].price,
              unitType: filterList[0].unitType,
              barcode: null,
              ntin: filterList[0].barcode,
              exciseStamp,
            }))
          } else {
            this.addItem(this.buildItem({
              name: filterList[0].name,
              price: filterList[0].price,
              unitType: filterList[0].unitType,
              barcode: filterList[0].barcode,
              exciseStamp,
            }))
          }
          this.playSound('found')
        } else {
          this.preNewItem = {
            name: filterList[0].name,
            price: filterList[0].price,
            unitType: filterList[0].unitType,
            exciseStamp,
          }
          if (barcode.startsWith('020') && barcode.length === 13) {
            this.preNewItem.ntin = filterList[0].barcode
          } else {
            this.preNewItem.barcode = filterList[0].barcode
          }

          this.editableItem = null
          this.editableItemIndex = null
          this.showItemDialog()
        }
      } else if (filterList.length > 1) {
        const doublicates = filterList.reduce((items, item, index) => {
          if (index === 0) {
            items = item.name
          } else {
            items = `${items}, ${item.name}`
          }
          return items
        }, [])
        this.showSnackbar({ message: this.$t('найдено_больше_одной_записи_с_данным_штрих_кодом', { items: doublicates }) })
        this.playSound('error')
      } else if (filterList.length === 0) {
        this.showSnackbar({ message: this.$t('позиция_с_данным_штрих_кодом_не_найдена'), timeout: 2000 })

        if (this.positionList.length === 0) {
          this.showConfirm({
            title: this.$t('прайс_лист_пуст_хотите_добавить_новую_запись'),
            resolveText: this.$t('добавить'),
            rejectText: this.$t('отменить'),
          }).then(() => {
            this.$router.push('/kkm/positions')
          }).catch(() => {})
        }

        this.playSound('error')
      }

      this.searchByBarcodeLoading = false
    },

    buildItem({
      name, price, unitType, barcode, ntin, exciseStamp,
    }) {
      const quantity = 1
      const sum = price

      const newItem = new fdo.kkm.proto.TicketRequest.Item({
        type: fdo.kkm.proto.TicketRequest.Item.ItemTypeEnum.ITEM_TYPE_COMMODITY,
        commodity: new fdo.kkm.proto.TicketRequest.Item.Commodity({
          name,
          barcode,
          ntin,
          sectionCode: '1',
          quantity: new Decimal(quantity).times(1000).toNumber(),
          price: this.getBillsAndCoinsMoney(price),
          sum: this.getBillsAndCoinsMoney(new Decimal(quantity).times(sum).toNumber().toFixed(2)),
          listExciseStamp: exciseStamp ? [exciseStamp] : null,
          measureUnitCode: this.unitTypes.find((ut) => ut.value === unitType).code,
          auxiliary: [
            new fdo.kkm.proto.KeyValuePair({
              key: 'UNIT_TYPE',
              value: unitType,
            }),
          ],
        }),
      })

      if (this.configuration.taxMode && this.dictionary.taxType[this.preferences.defaultTaxType].rate >= 0) {
        newItem.commodity.taxes = [
          new fdo.kkm.proto.TicketRequest.Tax({
            taxType: 100,
            taxationType: this.dictionary.taxationType[this.configuration.taxationType].code,
            percent: new Decimal(this.dictionary.taxType[this.preferences.defaultTaxType].rate).times(1000).toNumber(),
            sum: this.getBillsAndCoinsMoney(new Decimal(sum)
              .dividedBy(new Decimal(this.dictionary.taxType[this.preferences.defaultTaxType].rate).add(100))
              .times(this.dictionary.taxType[this.preferences.defaultTaxType].rate)
              .toNumber()
              .toFixed(2)),
            isInTotalSum: true,
          }),
        ]
      }

      return newItem
    },

    playSound(type) {
      if (!this.$isCordova()) {
        const audio = new Audio(`/static/sounds/${type}.wav`)
        audio.play()
      }
    },

    // -------------------------------------- Items --------------------------------------
    createNewItem() {
      this.preNewItem = null
      this.editableItem = null
      this.editableItemIndex = null
      this.showItemDialog()
    },

    editItem($index) {
      this.preNewItem = null
      this.editableItemIndex = $index
      this.editableItem = this.ticketRequest.items[$index]
      this.showItemDialog()
    },

    saveItem(item) {
      Vue.set(this.ticketRequest.items, this.editableItemIndex, item)
      this.recalculateDiscountMarkup()
    },

    addItem(item) {
      this.ticketRequest.items.push(item)
      this.recalculateDiscountMarkup()
    },

    deleteItem() {
      this.$delete(this.ticketRequest.items, this.editableItemIndex)
      this.recalculateDiscountMarkup()
    },

    showItemDialog() {
      this.itemDialogRecreate = false
      this.itemDialog = false
      this.$nextTick(() => {
        this.itemDialogRecreate = true
        this.$nextTick(() => {
          this.itemDialog = true
        })
      })
    },

    // -------------------------------------- Payments --------------------------------------
    fillPayment(event, payment) {
      if (event.target.id === 'selectPayment') return
      if (payment.type === 'PAYMENT_QR' && !this.halykQRConnected) {
        this.goToHalykQrSettings('DETAILS')
        return
      }
      if (this.ticketRequest.items.length === 0) {
        this.showSnackbar({ message: this.$t('добавьте_как_минимум_одну_позицию'), timeout: 1500 })
      } else {
        this.payments.map((p) => {
          p.sum = 0
          return p
        })
        payment.sum = this.totalSum
      }
    },

    selectPayment(event, payment) {
      window.blur(event)
      if (payment.type === 'PAYMENT_QR' && !this.halykQRConnected) {
        this.goToHalykQrSettings('DETAILS')
        return
      }
      if (this.ticketRequest.items.length === 0) {
        this.showSnackbar({ message: this.$t('добавьте_как_минимум_одну_позицию'), timeout: 1500 })
        return
      }

      this.selectedPayment = { ...payment }
      this.showPaymentDialog()
    },

    savePayment(payment) {
      this.payments.find((p) => p.type === payment.type).sum = payment.sum
    },

    showPaymentDialog() {
      this.paymentDialogRecreate = false
      this.paymentDialog = false
      this.$nextTick(() => {
        this.paymentDialogRecreate = true
        this.$nextTick(() => {
          this.paymentDialog = true
        })
      })
    },

    // -------------------------------------- Customer Iin Bin ------------------------------------
    editСustomerIinBin() {
      this.customerIinBinDialog = true
    },

    saveCustomerIinBin(customerIinBin) {
      this.customerIinBin = customerIinBin
    },

    // -------------------------------------- Discount/Markup -------------------------------------
    editDiscountMarkup() {
      if (this.ticketRequest.items.length === 0) {
        this.showSnackbar({ message: this.$t('добавьте_как_минимум_одну_позицию'), timeout: 1500 })
        return
      }

      this.selectedDiscountMarkup = { ...this.discountMarkup }
      this.showDiscountMarkup()
    },

    showDiscountMarkup() {
      this.discountMarkupDialogRecreate = false
      this.discountMarkupDialog = false
      this.$nextTick(() => {
        this.discountMarkupDialogRecreate = true
        this.$nextTick(() => {
          this.discountMarkupDialog = true
        })
      })
    },

    saveDiscountMarkup(discountMarkup) {
      this.discountMarkup = discountMarkup
    },

    recalculateDiscountMarkup() {
      switch (this.discountMarkup.type) {
        case 'DISCOUNT_PERCENTAGE':
          this.discountMarkup.sum = new Decimal(new Decimal(this.totalSumWithoutDiscountMarkup).dividedBy(100).times(this.discountMarkup.valueOrPecentage)).toNumber().toFixed(2)
          break
        case 'DISCOUNT_CURRENCY':
          this.discountMarkup.sum = new Decimal(this.discountMarkup.valueOrPecentage).toNumber()
          break
        case 'MARKUP_PERCENTAGE':
          this.discountMarkup.sum = new Decimal(this.totalSumWithoutDiscountMarkup).dividedBy(100).times(this.discountMarkup.valueOrPecentage).toNumber()
            .toFixed(2)
          break
        case 'MARKUP_CURRENCY':
          this.discountMarkup.sum = new Decimal(this.discountMarkup.valueOrPecentage).toNumber()
          break
        default:
          break
      }
    },
    // -------------------------------------- Ticket Request --------------------------------------
    prepareTicketRequest() {
      if (this.ticketRequest.items.length === 0) {
        this.showSnackbar({ message: this.$t('добавьте_как_минимум_одну_позицию'), timeout: 2000 })
        return
      }

      if (this.paymentsSum === 0) {
        this.showSnackbar({ message: this.$t('выберите_тип_оплаты'), timeout: 2000 })
        return
      }

      if (new Decimal(this.paymentsSum).lessThan(this.totalSum)) {
        this.showSnackbar({ message: this.$t('недостаточно_суммы_для_оплаты'), timeout: 2000 })
        return
      }

      if (this.takenCash === 0 && this.changeCash > 0) {
        this.showSnackbar({ message: this.$t('сдача_возможна_только_при_наличии_наличного_расчета'), timeout: 3000 })
        return
      }

      if (this.changeCash > this.takenCash) {
        this.showSnackbar({ message: this.$t('сумма_сдачи_не_может_быть_больше_суммы_принятой_наличности'), timeout: 3000 })
        return
      }

      // Halyk QR не поддерживает смешанную оплату - валидируем здесь,
      // пока пользователь ещё может поправить суммы
      const qrSum = this.payments.find((p) => p.type === 'PAYMENT_QR').sum
      if (qrSum > 0 && this.payments.some((p) => p.type !== 'PAYMENT_QR' && p.sum > 0)) {
        this.showSnackbar({ message: this.$t('смешанная_оплата_не_поддерживается_в_halyk_qr'), timeout: 3000 })
        return
      }

      this.ticketRequest.operation = fdo.kkm.proto.OperationTypeEnum.OPERATION_SELL
      this.ticketRequest.domain = new fdo.kkm.proto.TicketRequest.Domain({ type: this.dictionary.domainType[this.preferences.domainType].code })

      this.payments.forEach(p => {
        if (p.sum > 0) {
          const sum = p.type === 'PAYMENT_CASH' ? new Decimal(p.sum).minus(this.changeCash).toNumber() : p.sum
          const payment = new fdo.kkm.proto.TicketRequest.Payment({
            type: this.toProtoPaymentType(p.type),
            sum: this.getBillsAndCoinsMoney(sum),
          })
          this.ticketRequest.payments.push(payment)
        }
      })

      const amounts = new fdo.kkm.proto.TicketRequest.Amounts({
        total: this.getBillsAndCoinsMoney(this.totalSum),
        taken: this.getBillsAndCoinsMoney(this.takenCash),
        change: this.getBillsAndCoinsMoney(this.changeCash),
      })

      if (this.discountMarkup.sum > 0) {
        const discountMarkup = new fdo.kkm.proto.TicketRequest.Modifier({
          sum: this.getBillsAndCoinsMoney(this.discountMarkup.sum),
          auxiliary: [
            new fdo.kkm.proto.KeyValuePair({
              key: this.discountMarkup.auxiliary.key,
              value: this.discountMarkup.auxiliary.value,
            }),
          ],
        })
        if (this.discountMarkup.type.includes('DISCOUNT')) {
          amounts.discount = discountMarkup
        } else {
          amounts.markup = discountMarkup
        }
      }
      this.ticketRequest.amounts = amounts

      // Не заменяем extensionOptions целиком, чтобы не потерять auxiliary (QR-метку)
      if (this.customerIinBin) {
        if (!this.ticketRequest.extensionOptions) {
          this.ticketRequest.extensionOptions = new fdo.kkm.proto.TicketRequest.ExtensionOptions()
        }
        this.ticketRequest.extensionOptions.customerIinOrBin = this.customerIinBin
      }
      this.setQrPaymentMarker(this.ticketRequest, qrSum > 0)

      this.setTicketRequest(this.ticketRequest)
      localStorage.setItem('rekassa.kz-ticket-prepared-from', 'DETAILS')
      this.$router.push('/draft')

      this.analyticsLogEvent({ eventName: 're_positions_prepare_draft' })
    },

    clear() {
      this.showConfirm({
        title: this.$t('вы_уверены_что_хотите_очистить'), resolveText: this.$t('очистить'), rejectText: this.$t('отменить'),
      }).then(() => {
        this.setTicketRequest(null)
        this.ticketRequest = new fdo.kkm.proto.TicketRequest()
        this.discountMarkup = {
          type: 'DISCOUNT_PERCENTAGE',
          valueOrPecentage: 0,
          sum: 0,
          auxiliary: {
            key: 'DISCOUNT',
            value: '0%',
          },
        }
        this.payments = [
          {
            type: 'PAYMENT_CASH',
            sum: 0,
          },
          {
            type: 'PAYMENT_CARD',
            sum: 0,
          },
          {
            type: 'PAYMENT_MOBILE',
            sum: 0,
          },
          {
            type: 'PAYMENT_QR',
            sum: 0,
          },
        ]
      }).catch(() => {})
    },

    // «Назад» (кнопка телефона / браузера) при открытом диалоге позиции или
    // прайс-листа (на мобилке они fullscreen и выглядят как отдельный экран)
    // закрывает диалог, а не уводит со страницы. Зовётся и из обёртки
    // TicketDetails.vue - у ребёнка route-guard сам не срабатывает
    closeDialogsOrExit(to, next) {
      if (this.itemDialog) {
        this.itemDialog = false
        next(false)
        return
      }
      if (this.positionsDialog) {
        this.positionsDialog = false
        next(false)
        return
      }
      this.prepareToExit(to, next)
    },

    prepareToExit(to, next) {
      if (to.name !== 'TicketDraft' && this.items.length > 0) {
        this.showConfirm({
          title: this.$t('вы_уверены_что_хотите_покинуть'), resolveText: this.$t('покинуть'), rejectText: this.$t('отменить'),
        }).then(() => {
          this.setTicketRequest(null)
          next()
        }).catch(() => {
          next(false)
        })
      } else {
        next()
      }
    },
  },

  beforeRouteLeave(to, from, next) {
    this.closeDialogsOrExit(to, next)
  },
}
</script>

<style lang="stylus" scoped>
.items
  .v-list-item__title, .v-list-item__subtitle
    white-space normal!important

.payments
  .v-list-item--active::before
    opacity 0!important

.no-color-background-list.v-list
  background-color transparent!important

.no-focus.v-icon:focus::after
  opacity 0!important
</style>

<style lang="stylus">
.autocomplete-with-append .v-input__append-outer
  margin-top 4px !important
  margin-left 4px !important
  margin-right -7px !important
</style>
